<template>
  <div>
    <div>
      <!-- <div v-if="fileAnswer">
        Скачать файл
        <a :href="fileAnswer" target="_blank">Скачать файл</a>
      </div> -->
      <v-file-input v-model="file" accept="image/*" label="Выбрать файл">
      </v-file-input>

      <div class="ta-center m-t-10 btn-content" v-if="file">
        <v-btn :loading="loading" @click="answer" class="mt-8" large color="info">
          Загрузить
        </v-btn>
      </div>
      <!-- <div class="ta-center m-t-10 btn-content" v-if="file">
        <span class="btn-def" >
          <button class="p-x-8" @click="answer" >Загрузить</button>
        </span>
      </div> -->
    </div>
  </div>
</template>
<script>

export default {
  props: {
    data: Object,
  },
  computed: {
    fileAnswer() {
      if (this.value && this.value.length) {
        return this.value[0]['file'];
      }
      return null;
    }
  },
  data() {
    return {
      file: null,
      loading: false
    }
  },
  methods: {
    async answer() {
      this.loading = true
      setTimeout(() => {
        this.loading = false
      }, 500);
    }
  },
}
</script>
